export default __webpack_public_path__ + "static/media/airtel.b008f3e7.jpg";